import React from "react";
import UsersService from "@velocity-ehs/user-utils-module";
import SolutionsHome from "./SolutionsHome";
import SigmaDashboard from "../Dashboard/SigmaDashboard";
import { useFlags } from "launchdarkly-react-client-sdk";

const ADVANCED_DASH_APPLICATION_CODE = "dash";

const HomePageSelector: React.FC = () => {
  const { enableAdvancedDashboardHomepageRouting } = useFlags();
  if (!enableAdvancedDashboardHomepageRouting) {
    return <SolutionsHome />;
  }

  const hasAdvancedDashboard =
    UsersService.customer?.applications?.items.some(
      (app: { code: string; isAssigned: boolean }) =>
        app.code === ADVANCED_DASH_APPLICATION_CODE && app.isAssigned === true
    ) ?? false;

  return hasAdvancedDashboard ? <SigmaDashboard /> : <SolutionsHome />;
};

export default HomePageSelector;
